import { ListEntity } from "./states";

export enum Order {
  Asc = "asc",
  Desc = "desc",
}

export enum RequestMethod {
  Get,
  Post,
  Put,
  Patch,
  Delete,
}

export interface AllOptions {
  id?: number;
  ticket?: number;
  instance?: number;
  lastUpdatedAt?: string;
}
export interface ListService<Type extends ListEntity> {
  all?: (options?: any) => Promise<Type[] | void>;
  load?: (options?: any, otherParams?: any) => Promise<Type | void>;
  add?: (
    entity: Type,
    request?: { requestUuid: string },
    parentId?: number
  ) => Promise<Type | void>;
  update?: (
    entity: Type,
    columns: any,
    request?: { requestUuid: string }
  ) => Promise<Type | void>;
  remove?: (
    entity: Type,
    request?: { requestUuid: string },
    parentId?: number
  ) => Promise<void>;
}

export enum AuthType {
  None = "INEXISTENT",
  External = "EXTERNAL",
  Native = "NATIVE",
  Legacy = "LEGACY",
  Migrated = "MIGRATED",
  Future = "FUTURE",
}
export interface Token {
  type: string;
  accessToken: string;
  refreshToken: string;
  expiresAt: Date;
}
